import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-remove-addon-dialog',
  templateUrl: './remove-addon-dialog.component.html',
  styleUrls: ['./remove-addon-dialog.component.css']
})
export class RemoveAddonDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  btndisabled  = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: number,
      private accountService: AccountService,
      private corporateService: CorporateService) { }

  ngOnInit() {
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onDeleteConfirm() {
    this.api_error = '';
    this.btndisabled = true;
    // tslint:disable-next-line:triple-equals
    if (this.data['type'] == 'account') {
      this.accountService.deleteAddon(this.data['accountId'], this.data['addonId'])
      .subscribe(
        data => {
          this.btndisabled = true;
          this.api_success = 'Addon removed Successfully';
          // this.api_success = 'Addon removed Successfully and It will get refelected on next bill cycle';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
          },
       (error) => {
        this.btndisabled = false;
        this.api_error = error.error;
        }
      );
    // tslint:disable-next-line:triple-equals
    }if (this.data['type'] == 'corporate') {
      this.corporateService.deleteAddon(this.data['corpId'], this.data['addonId'])
      .subscribe(
        data => {
          this.btndisabled = true;
          this.api_success = 'Addon removed Successfully';
          // this.api_success = 'Addon removed Successfully and It will get refelected on next bill cycle';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
          },
       (error) => {
        this.btndisabled = false;
        this.api_error = error.error;
        }
      );
    }
 
  }

}
